import { statesData } from "@/components/common/addressInput/common";
import { Button, ButtonType } from "@/components/common/button";
import { SelectField } from "@/components/common/select";
import { useIsMicrodose } from "@/hooks/useIsMicrodose";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { MICRODOSE_EXCLUDED_STATES } from "../../context/common";

const MS_STATE_ERROR_MESSAGE =
  "Currently, we don't offer any products in your state";

export const availableStateOptions = statesData.map((state) => ({
  value: state.abbreviation,
  label: state.state,
}));

const SelectState = ({
  question,
  setQuestionAnswer,
  questionValue,
  setQuestionValue,
}: QuizQuestionProps<string>) => {
  const { isMicrodose } = useIsMicrodose();
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setQuestionValue(e.target.value);
  };

  // we currently do not support MS state at all
  const excludedStates = isMicrodose ? MICRODOSE_EXCLUDED_STATES : ["MS"];

  // if no products for this state at all
  const isUnavailableState = excludedStates.includes(questionValue ?? "");

  return (
    <>
      <SelectField
        name="state"
        label=""
        options={availableStateOptions}
        placeholder="Select a state"
        value={questionValue ?? ""}
        onChange={handleChange}
        error={
          isUnavailableState
            ? "Currently, we don't offer any products in your state"
            : undefined
        }
      />

      <Button
        type={ButtonType.CONTINUE}
        disabled={!questionValue || isUnavailableState}
        onClick={() => setQuestionAnswer(questionValue)}
      />
    </>
  );
};

export { SelectState };
